import './src/gravity_forms_ajax'
import './src/filter_lists'
import './src/cookie_consent'

import $ from 'jquery'
import UIkit from '../../../node_modules/uikit/dist/js/uikit-core.js';
// import icons from '../../../node_modules/uikit/dist/js/uikit-icons.min.js';
import Parallax from '../../../node_modules/uikit/dist/js/components/parallax.min.js';
import SlideShow from '../../../node_modules/uikit/dist/js/components/slideshow.min.js';
import Slider from '../../../node_modules/uikit/dist/js/components/slider.min.js';
import Lightbox from '../../../node_modules/uikit/dist/js/components/lightbox.min.js';

// UIkit.use(icons);
UIkit.component('parallax', Parallax);
UIkit.component('slideshow', SlideShow);
UIkit.component('slider', Slider);
UIkit.component('lightbox', Lightbox);

window.UIkit = UIkit;
window.jQuery = $;



// WEBPACK FOOTER //
// ./resources/assets/js/app.js